import React from 'react'
//import logo from '../../assets/AgroH-.png'
import logo from '../../assets/AgroHLogoFINAL.png'
import { Link, useNavigate } from 'react-router-dom'

function Logo({ size, setCategoriaDesplegada,from }) {
  const navigate = useNavigate()
  const handleClick = () => {
    if (from === " n") {
      setCategoriaDesplegada(false)
    }
    navigate('/')
  }
  return (
    <button onClick={handleClick}><img className={`${size}`} src={logo} /></button>
  )
}

export default Logo